import { useEffect } from 'react';

const SECTION_IDS = ['home', 'services', 'about', 'why-us', 'contact'];

export function useSectionHash() {
  useEffect(() => {
    // On initial load, scroll to hash if present
    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }

    const handleIntersect = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log(`Section in view: #${entry.target.id}, ratio: ${entry.intersectionRatio}`);
        }
      });
      // Find the first section that is intersecting
      const visible = entries
        .filter(entry => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) {
        const id = visible.target.id;
        if (window.location.hash !== `#${id}`) {
          console.log(`Updating hash to #${id}`);
          window.history.replaceState(null, '', `/#${id}`);
        }
      }
    };

    const observer = new window.IntersectionObserver(handleIntersect, {
      root: null,
      rootMargin: '0px 0px -40% 0px', // More sensitive
      threshold: 0.1, // More sensitive
    });

    SECTION_IDS.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        console.log(`Observing section: #${id}`);
        observer.observe(el);
      } else {
        console.warn(`Section not found: #${id}`);
      }
    });

    return () => observer.disconnect();
  }, []);
} 